import { Masonry } from '@/components/shared/Masonry/Masonry';
import NoteWrapper from './NoteWrapper';
import React from 'react';
import { Note } from '@/store/notesStore';

interface NotesGridProps {
  notes: Note[];
  searchQuery?: string;
}

const NotesGrid: React.FC<NotesGridProps> = ({ notes, searchQuery }) => {
  return (
    <Masonry
      columns={{
        0: 1,     // Mobile: 1 column (full width)
        640: 2,   // Tablet: 2 columns
        900: 3,   // Small desktop: 3 columns
        1200: 4,  // Medium desktop: 4 columns
        1440: 5,  // Large desktop: 5 columns
        1680: 6,  // XL desktop: 6 columns
        1920: 7   // XXL desktop: 7 columns
      }}
      gap={20}
      className="notes-grid"
    >
      {notes.map(note => (
        <NoteWrapper
          key={note.id}
          note={note}
          searchQuery={searchQuery}
        />
      ))}
    </Masonry>
  );
};

export default NotesGrid;
